<template>
  <input
    type="text"
    class="h-9 px-3 pe-10 w-full xl:max-w-[250px] border rounded-lg focus:ring-0 outline-none dark:bg-slate-900"
    name="s"
    id="searchItem"
    placeholder="Buscar..."
  />
</template>
<script setup></script>
<style lang=""></style>
